import { ajaxSend } from '../../../../api/api';
export function addCallerRequest({ csid, userId }) {
    return ajaxSend({
        method: 'PUT',
        path: `/v2/conversations/${csid}/add`,
        data: { userId },
    });
}
export function removeCallerRequest({ csid, userId }) {
    return ajaxSend({
        method: 'PUT',
        path: `/v2/conversations/${csid}/remove`,
        data: { userId },
    });
}
export function setHoldStatusOnCallerRequest({ hold, csid, userId, }) {
    return ajaxSend({
        method: 'PUT',
        path: `/v2/conversations/${csid}/hold`,
        data: { userId, hold },
    });
}
